import React, { Component } from 'react';
import { Form, Input, Tabs, message, Select, DatePicker, Button, Radio,Modal,Cascader,Checkbox,Col,Icon,Row } from 'antd';
import axios from 'axios';
import API from '../../../../API/api';
import moment from 'moment';

const { RangePicker } = DatePicker;
const FormItem = Form.Item;
const TabPane = Tabs.TabPane;
const Option = Select.Option;

class CreateTask extends Component{
    state = {
        album_cover_img_4_3:'',
        album_cover_img_16_9:'',
        name:'',
        source:'',
        description:'',
        role_name:'',
    }
    onOk = () => {
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                let data = {};
                data.name = values.name;
                data.album_cover_img_4_3=this.state.album_cover_img_4_3;
                data.album_cover_img_16_9=this.state.album_cover_img_16_9;
                data.source=values.source;
                data.description=values.description;
                data.role_name=values.role_name;


                if(!data.album_cover_img_4_3){return message.error('请上传4:3封面')}
                if(!data.album_cover_img_16_9){return message.error('请上传16:9封面')}

                this.setState({disabled:true})
                if(this.props.albumId){
                    data.album_id = this.props.albumId
                    axios.post(API.ALBUM_EDIT,data).then((res)=>{
                        res = res.data
                        if (res.code === 0) {
                            message.success('任务编辑成功');
                            this.setState({ loading: false, visible:false,disabled:false});
                            this.props.refresh();
                            this.props.onCancel();
                        }else{
                            message.error(res.message);
                            this.setState({ loading: false,disabled:false});
                        }
                    },(error)=>{
                        message.error('网络错误！');
                    });
                }else{
                    axios.post(API.ALBUM_ADD,data).then((res)=>{
                        res = res.data
                        if (res.code === 0) {
                            message.success('任务创建成功');
                            this.setState({ loading: false, visible:false,disabled:false});
                            this.props.refresh();
                            this.props.onCancel();
                        }else{
                            message.error(res.message);
                            this.setState({ loading: false,disabled:false});
                        }
                    },(error)=>{
                        message.error('网络错误！');
                    });
                }
            }
        });
    }
    uptoken = ""

    /*
    *
    * 上传图片
    * */
    upload = () => {
        const __this = this;
        let option = {
            runtimes: 'html5,html4',
            browse_button: `album_cover_img_16_9_upload`,
            max_file_size: '100mb',
            dragdrop: true,
            chunk_size: '4mb',
            uptoken: this.uptoken,
            // uptoken_url: me.options.uploadTokenUrl + "?token=" + ReadCookie(COOKIE_NAME),
            domain: 'https://tikuqiniu.knowbox.cn/',
            drop_element: `album_cover_img_16_9_preview`,
            get_new_uptoken: false,
            save_key: true,
            auto_start: true,
            disable_statistics_report: true,
            log_level: 0,
            filters: {
                max_file_size: '100mb',
                prevent_duplicates: true,
                //Specify what files to browse for
                mime_types: [
                    {title: "image files", extensions: "jpeg,png,jpg"},
                ]
            },
            init: {
                'FilesAdded': function (up, files) {
                },
                'BeforeUpload': function (up, file) {
                },
                'UploadProgress': function (up, file) {
                },
                'UploadComplete': function () {
                },
                'FileUploaded': function (up, file, info) {
                    let res = JSON.parse(info);
                    let domain = up.getOption('domain');
                    __this.setState({album_cover_img_16_9:`${domain}${res.key}`})

                }
            },
            'Error': function (up, err, errTip) {
                console.log(err.message);
            }
            ,
            'Key': function (up, file) {
                var key = "";
                // do something with key
                return key
            }
        }
        let Qalbum_cover_img_16_9 = new window.QiniuJsSDK();
        Qalbum_cover_img_16_9.uploader(option);


        let optionalbum_cover_img_4_3 = {
            runtimes: 'html5,html4',
            browse_button: `album_cover_img_4_3_upload`,
            max_file_size: '100mb',
            dragdrop: true,
            chunk_size: '4mb',
            uptoken:this.uptoken,
            // uptoken_url: me.options.uploadTokenUrl + "?token=" + ReadCookie(COOKIE_NAME),
            domain: 'https://tikuqiniu.knowbox.cn/',
            drop_element: `album_cover_img_4_3_preview`,
            get_new_uptoken: false,
            save_key: true,
            auto_start: true,
            disable_statistics_report:true,
            log_level: 0,
            filters: {
                max_file_size: '100mb',
                prevent_duplicates: true,
                //Specify what files to browse for
                mime_types: [
                    { title: "image files", extensions: "jpeg,png,jpg" },
                ]
            },
            init: {
                'FilesAdded': function(up, files) {
                },
                'BeforeUpload': function(up, file) {
                },
                'UploadProgress': function(up, file) {
                },
                'UploadComplete': function() {
                },
                'FileUploaded': function(up, file, info) {
                    let res = JSON.parse(info);
                    let domain = up.getOption('domain');
                    __this.setState({album_cover_img_4_3:`${domain}${res.key}`})

                }
            },
            'Error': function(up, err, errTip) {
                console.log(err.message);
            }
            ,
            'Key': function(up, file) {
                var key = "";
                // do something with key
                return key
            }
        }
        let Qalbum_cover_img_4_3 = new window.QiniuJsSDK();
        Qalbum_cover_img_4_3.uploader(optionalbum_cover_img_4_3);
    }
    componentDidMount(){
        axios.post(API.UPLOAD_TOKEN).then((res)=>{
            res = res.data
            if (res.code === 0) {
                this.uptoken = res.data.uptoken
                this.upload();
            }else{
                message.error(res.message);
            }
        },(error)=>{
            message.error('网络错误！');
        });

        if(this.props.albumId){
            axios.post(API.ALBUM_DETAIL,{album_id:this.props.albumId}).then((res)=>{
                res = res.data
                if (res.code === 0) {
                    this.setState({
                        name:res.data.name,
                        album_cover_img_4_3:res.data.album_cover_img_4_3,
                        album_cover_img_16_9:res.data.album_cover_img_16_9,
                        source:res.data.source,
                        description:res.data.description,
                        role_name:res.data.role_name,
                    })

                }else{
                    message.error(res.message);
                }
            },(error)=>{
                message.error('网络错误！');
            });
        }

    }


    render(){
        const {visible } = this.props;
        const { getFieldDecorator } = this.props.form;
        const formItemLayout = {
            labelCol: {
                xs: { span: 12 },
                sm: { span: 5 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 14 },
            },
        };
        return(
            <div>
                <Modal
                    visible={visible}
                    title={this.props.albumId?"修改任务":"新建任务"}
                    onOk={this.onOk}
                    onCancel={this.props.onCancel}
                    footer={[
                        <Button disabled={this.state.disabled} key="back" size="large" onClick={this.props.onCancel}>取消</Button>,
                        <Button disabled={this.state.disabled} key="submit" type="primary" size="large" loading={this.state.loading} onClick={this.onOk}>
                            {this.props.albumId?"修改任务":"创建任务"}
                        </Button>,
                    ]}
                >
                    <Form>
                        <FormItem
                            {...formItemLayout}
                            label="专辑名"
                            hasFeedback
                            style={{marginBottom:10,marginRight:10,}}
                        >
                            {getFieldDecorator('name', {
                                initialValue:this.state.name,
                                rules: [{
                                    type: 'string', message: '请输入正确的任务名称',
                                }, {
                                    required: true, message: '请输入任务名称',
                                }],
                            })(
                                <Input />
                            )}
                        </FormItem>


                        <FormItem
                            {...formItemLayout}
                            label="专辑来源"
                            hasFeedback
                            style={{marginBottom:10,marginRight:10,}}
                        >
                            {getFieldDecorator('source', {
                                initialValue:this.state.source,

                            })(
                                <Input />
                            )}
                        </FormItem>
                        <FormItem
                            {...formItemLayout}
                            label="专辑简介"
                            hasFeedback
                            style={{marginBottom:10,marginRight:10,}}
                        >
                            {getFieldDecorator('description', {
                                initialValue:this.state.description,
                                rules: [{
                                    type: 'string', message: '请输入正确的转接简介',
                                }, {
                                    required: true, message: '请输入任务专辑简介',
                                }],
                            })(
                                <Input />
                            )}
                        </FormItem>
                        <FormItem
                            {...formItemLayout}
                            label="角色名"
                            hasFeedback
                            style={{marginBottom:10,marginRight:10,}}
                        >
                            {getFieldDecorator('role_name', {
                                initialValue:this.state.role_name,
                            })(
                                <Input />
                            )}
                        </FormItem>
                        <Row className="row-padding" style={{overflow:'hidden'}}>
                            <Col span={5}>
                            </Col>
                            <Col span={19}>

                                <div style={{color:'#999'}}>
                                    *多个角色以'|'隔开
                                </div>

                            </Col>
                        </Row>
                        <Row className="row-padding" style={{overflow:'hidden',minHeight:200}}>
                            <Col span={5}>
                                <p className="item-title" style={{textAlign:'right',fontWeight:'bold'}}>上传封面：</p>
                            </Col>
                            <Col span={19}>

                                <div style={{textAlign:'center',postion:'relative',overflow:'hidden',minHeight:200}}>
                                    <div style={{textAlign:'left',fontSize:16}}>
                                        <Button type="primary" style={{marginTop:5,fontSize:20,verticalAlign:'top'}} id={`album_cover_img_16_9_upload`}>
                                            &nbsp;<Icon style={{fontWeight:900}} type="upload" />&nbsp;
                                        </Button>
                                        <div style={{display:'inline-block',marginLeft:20}}>
                                            <div>图片比例16:9</div>
                                            <div>图片格式JPG</div>
                                        </div>
                                    </div>
                                    <div style={{position:'absolute',border:'solid 1px #999',padding:'10px'}}>
                                        {
                                            (this.state.album_cover_img_16_9)?
                                                <img src={this.state.album_cover_img_16_9}  style={{width:160,height:120}} alt="" onClick={()=>{this.setState({modalSrc:this.state.album_cover_img_16_9})}}/>
                                                :
                                                <div id={`album_cover_img_16_9_preview`} className={'video_cover_img_preview'} style={{textAlign:'left',position:'relative',width:160,minHeight:120}}>
                                                    <div style={{fontSize:19,color:'#108ee9',textAlign:'center'}}>
                                                        图片预览区
                                                    </div>
                                                </div>
                                        }
                                    </div>
                                </div>

                            </Col>
                        </Row>
                        <Row className="row-padding" style={{overflow:'hidden',minHeight:200}}>
                            <Col span={5}>
                                <p className="item-title" style={{textAlign:'right',fontWeight:'bold'}}>上传封面：</p>
                            </Col>
                            <Col span={19}>

                                <div style={{textAlign:'center',postion:'relative',overflow:'hidden',minHeight:200}}>
                                    <div style={{textAlign:'left',fontSize:16}}>
                                        <Button type="primary" style={{marginTop:5,fontSize:20,verticalAlign:'top'}} id={`album_cover_img_4_3_upload`}>
                                            &nbsp;<Icon style={{fontWeight:900}} type="upload" />&nbsp;
                                        </Button>
                                        <div style={{display:'inline-block',marginLeft:20}}>
                                            <div>图片比例4:3</div>
                                            <div>图片格式JPG</div>
                                        </div>
                                    </div>
                                    <div style={{position:'absolute',border:'solid 1px #999',padding:'10px'}}>
                                        {
                                            (this.state.album_cover_img_4_3)?
                                                <img src={this.state.album_cover_img_4_3} style={{width:160,height:120}} alt="" onClick={()=>{this.setState({modalSrc:this.state.album_cover_img_4_3})}}/>
                                                :
                                                <div id={`album_cover_img_4_3_preview`} className={'video_cover_img_preview'} style={{textAlign:'left',position:'relative',width:160,minHeight:120}}>
                                                    <div style={{fontSize:19,color:'#108ee9',textAlign:'center'}}>
                                                        图片预览区
                                                    </div>
                                                </div>
                                        }
                                    </div>
                                </div>

                            </Col>
                        </Row>
                    </Form>
                </Modal>
                <Modal visible={!!this.state.modalSrc}
                       footer={''}
                       className={'ModalImage'}
                       onCancel={() => this.setState({modalSrc: false})}>
                    <img src={this.state.modalSrc} alt="" onClick={() => this.setState({modalSrc: false})}/>
                </Modal>
            </div>

        );
    }

}
const WrappedCreateTaskForm = Form.create()(CreateTask);
export default WrappedCreateTaskForm


// WEBPACK FOOTER //
// ./src/entry_app/knowledge_assist/album/creat_task/view.js